// extracted by mini-css-extract-plugin
module.exports = {"control":"SoundPicker_control__3Qfpw"};